import React from "react";

import ChatContainer from "./ChatContainer";

const App = () => {
  return (
    <div className="app">
     
      <ChatContainer />
    </div>
  );
};

export default App;

